import debounce from '../../../assets/js/base/_debounce.js';

function programList( node ) {
	const search  = node.querySelector( '.program-list__search' );
	const noItems = node.querySelector( '.program-list__no-items' );
	const results = Array.from( node.querySelectorAll( '.program-list__item' ) ).map( node => ( {
		node,
		value: node.textContent.toLowerCase().replace(/\s/g, ''),
	} ) );

	const setState = ( e ) => {
		const input   = search.value.toLowerCase().replace( /\s/g, '' );
		let   matches = 0;

		for ( const result of results ) {
			if ( result.value.includes( input ) ) {
				matches++;
				result.node.removeAttribute( 'hidden' );
			} else {
				result.node.hidden = true;
			}
		}

		if ( matches > 0 ) {
			noItems.hidden = true;
		} else {
			noItems.removeAttribute( 'hidden' );
		}
	}

	search.addEventListener( 'input', debounce( setState, 50 ) );
	setState();
}

for ( const node of document.querySelectorAll( '.program-list' ) ) {
	programList( node );
}
